var App = App || {};

App.Checkout = (function ($) {
    "use strict";

    let authorizeNetConfig = {
        clientKey: null,
        apiLoginID: null
    };

    let $paymentForm = {}, 
    $submitButton = {};


    function init() {
        $paymentForm = $("form#capture-payment");
        $submitButton = $paymentForm.find('button[type="submit"]');

        let $createAccountCheckbox = $paymentForm.find("#payment-create-account"),
            $summary = $(".block.block-checkout-details-forms .checkout-box.summary-box");

        loadAuthorizeNetConfig();

        if ($summary.length) {
            $summary.each(function () {
                var $self = $(this);
                var showButton = $self.find("button.show-summary");
                var hideButton = $self.find("button.hide-summary");

                showButton.each(function () {
                    $(this).on("click", function () {
                        $self.removeClass("mobile-hide")
                    });
                });

                hideButton.each(function () {
                    $(this).on("click", function () {
                        $self.addClass("mobile-hide")
                    });
                });
            });
        }

        $paymentForm.on("submit", function (e) {
            e.preventDefault();

            if ($paymentForm[0].checkValidity()) {
                var authData = {
                    clientKey: authorizeNetConfig.clientKey,
                    apiLoginID: authorizeNetConfig.apiLoginID
                };

                var cardData = {
                    cardNumber: $paymentForm.find("#cardNumber").val().replace(/\s/g, ''),
                    month: $paymentForm.find("#expMonth").val(),
                    year: $paymentForm.find("#expYear").val(),
                    cardCode: $paymentForm.find("#cardCode").val()
                };

                var secureData = {
                    authData: authData,
                    cardData: cardData
                };

                if (typeof Accept === "undefined" || !Accept.dispatchData) {
                    App.Base.ShowError("Secure payment services failed to load. Please disable content blockers or try again.");
                    return;
                }

                if (!authorizeNetConfig.clientKey || !authorizeNetConfig.apiLoginID) {
                    App.Base.ShowError("Payment configuration could not be loaded. Please refresh the page and try again.");
                    return;
                }

                Accept.dispatchData(secureData, function (response) {
                    if (response.messages.resultCode === "Error") {
                        var errorMessages = response.messages.message.map(function (msg) {
                            return msg.code + ": " + msg.text;
                        }).join("<br>");

                        App.Base.ShowError(errorMessages);
                    } else {
                        var payload = {
                            cardholderName: $paymentForm.find("#cardholderName").val(),
                            dataDescriptor: response.opaqueData.dataDescriptor,
                            dataValue: response.opaqueData.dataValue
                        };

                        App.Spinner.startSpinner($submitButton, "Processing...");
                        var token = $('meta[name="request-verification-token"]').attr('content');

                        $.ajax({
                            url: '/api/cart/capture_payment',
                            contentType: 'application/json; charset=utf-8',
                            method: 'POST',
                            data: JSON.stringify(payload),
                            headers: { 'RequestVerificationToken': token },
                            dataType: 'json'
                        }).done(function (data, textStatus, jqXHR) {
                            window.location.href = "/checkout/checkout-confirmation?orderId=" + data.orderSummary.orderId;
                        }).fail(function (jqXHR) {
                            var baseMessage = "Unable to complete request. Please try again.";

                            if (jqXHR.status === 429)
                                baseMessage = "Too many requests. Please try again in a few minutes.";

                            var providerMessage =
                                jqXHR.responseJSON &&
                                    jqXHR.responseJSON.message
                                    ? jqXHR.responseJSON.message + " "
                                    : "";

                            App.Base.ShowError(providerMessage + baseMessage);
                            App.Spinner.stopSpinner($submitButton);
                        });
                    }
                });
            }

            $paymentForm.addClass('was-validated');
        });

        $createAccountCheckbox.on("change", function () {
            if (this.checked) {
                var token = $('meta[name="request-verification-token"]').attr('content');
                $.ajax({
                    url: '/api/cart/refresh',
                    contentType: 'application/json; charset=utf-8',
                    method: 'GET',
                    dataType: 'json',
                    headers: { 'RequestVerificationToken': token }
                }).done(function (response) {
                    if (response.status === "Success" && response.orderSummary) {
                        const order = response.orderSummary;
                        const billing = order.billingAddress || {};

                        const firstName = order.firstName || billing.firstName || "";
                        const lastName = order.lastName || billing.lastName || "";
                        const email = order.email || billing.email || "";

                        const $offcanvas = $("#register-offcanvas");

                        $offcanvas.find("#register-first-name").val(firstName);
                        $offcanvas.find("#register-last-name").val(lastName);
                        $offcanvas.find("#register-email").val(email);
                    }
                }).fail(function () {
                    App.Base.ShowError("Unable to retrieve cart data for registration.");
                }).always(function () {
                    const offcanvas = new bootstrap.Offcanvas('#register-offcanvas');
                    offcanvas.show();
                });
            }
        });
    }

    function loadAuthorizeNetConfig() {
        var token = $('meta[name="request-verification-token"]').attr('content');
        $.ajax({
            url: '/api/cart/authorize_config',
            method: 'GET',
            dataType: 'json',
            headers: { 'RequestVerificationToken': token }
        }).done(function (config) {
            authorizeNetConfig.clientKey = config.clientKey;
            authorizeNetConfig.apiLoginID = config.apiLoginID;
        }).fail(function () {
            console.error("Failed to load Authorize.NET configuration");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
	App.Checkout.init();
});